import {DocumentNode} from "graphql";

export interface StoreItem {
  id: string;
  name: string;
}

export interface StoreItemInput {
  entity: StoreItemEntity;
  input?: object;
  mutation: DocumentNode;
  isInput: boolean;
}

export interface StoreItemDeleteInput {
  entity: StoreItemEntity;
  id: string;
  input: object;
  mutation: DocumentNode;
}

export interface StoreItemFiltering {
  filtering: object;
  isNotFiltering?: boolean;
  query: DocumentNode;
  entity: StoreItemEntity;
}


export enum StoreItemEntity {
  institutionDesignation = 'institutionDesignation',
  currencyType = 'currencyType',
  formResponse = 'formResponse',

  newsCategory = 'newsCategory',
  statisticSiteCategory = 'statisticSiteCategory',
  statisticSite = 'statisticSite',
  newsArticle = 'newsArticle',
  faqs = 'faqs',
  carouselItem = 'carouselItem',
  relatedSite = 'relatedSite',
  privacyPolicyTermsCondition = 'privacyPolicyTermsCondition',
  contactCenter = 'contactCenter',
  contactUs = 'contactUs',
  aboutUs = 'aboutUs',
  objective = 'objective',
  benefit = 'benefit',
  approvalRoster = 'approvalRoster',
}
